module.exports = __webpack_public_path__ + "static/media/M-Core OFC + FRP Master Catalogue (7.25 x 10.25 in).f920163d.pdf";